
import { useEffect, useState } from "react";
import OrdersTab from "./OrdersTab";
import DownloadsTab from "./DownloadsTab";
import PerfilTab from "./PerfilTab";
import { apiGet } from "../../lib/api.js";

export default function ContaPage() {
  const [ok, setOk] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        await apiGet("/auth/me"); // ping à sessão
        setOk(true);
      } catch {
        setOk(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <div className="container py-5">A carregar…</div>;
  if (!ok)
    return (
      <div className="container py-5">
        <div className="alert alert-warning">
          Precisas de iniciar sessão para aceder à tua conta.
        </div>
      </div>
    );

  return (
    <div className="container py-4">
      <h1 className="mb-3">A minha conta</h1>

      <ul className="nav nav-tabs" role="tablist">
        <li className="nav-item" role="presentation">
          <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#tab-orders" type="button" role="tab">
            Encomendas
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#tab-downloads" type="button" role="tab">
            Downloads
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#tab-profile" type="button" role="tab">
            Perfil
          </button>
        </li>
      </ul>

      <div className="tab-content border-start border-end border-bottom p-3 rounded-bottom">
        <div id="tab-orders" className="tab-pane fade show active" role="tabpanel">
          <OrdersTab />
        </div>
        <div id="tab-downloads" className="tab-pane fade" role="tabpanel">
          <DownloadsTab />
        </div>
        <div id="tab-profile" className="tab-pane fade" role="tabpanel">
          <PerfilTab />
        </div>
      </div>
    </div>
  );
}
